import React from "react";
import { FiCalendar, FiClock } from "react-icons/fi";

const weekdays = [
  { value: "mon", label: "Thứ 2" },
  { value: "tue", label: "Thứ 3" },
  { value: "wed", label: "Thứ 4" },
  { value: "thu", label: "Thứ 5" },
  { value: "fri", label: "Thứ 6" },
  { value: "sat", label: "Thứ 7" },
  { value: "sun", label: "Chủ nhật" },
];

export function formatSchedule(schedule = []) {
  if (!Array.isArray(schedule) || schedule.length === 0) return "Chưa có lịch học";

  const items = [];
  schedule.forEach((row) => {
    const dayLabels = (row.days || [])
      .map((d) => weekdays.find((w) => w.value === d)?.label || d)
      .filter(Boolean)
      .join(", ");

    if (dayLabels && row.startTime && row.endTime) {
      items.push(`${dayLabels}: ${row.startTime}–${row.endTime}`);
    }
  });

  return items.length ? items.join(" • ") : "Chưa có lịch học";
}

export default function StudentClassSchedule({ schedule = [] }) {
  const validRows = Array.isArray(schedule)
    ? schedule.filter((row) => Array.isArray(row.days) && row.days.length && row.startTime && row.endTime)
    : [];

  if (validRows.length === 0) {
    return (
      <div className="rounded-2xl border bg-white p-5 text-slate-600">
        <div className="flex items-center gap-2 font-semibold text-slate-900 mb-2">
          <FiCalendar /> Lịch học
        </div>
        <p>Chưa có lịch học cho lớp này.</p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border bg-white p-5">
      <div className="flex items-center gap-2 font-semibold text-slate-900 mb-4">
        <FiCalendar /> Lịch học
      </div>

      <div className="space-y-3">
        {validRows.map((row, index) => (
          <div key={`${row.startTime}-${row.endTime}-${index}`} className="rounded-xl border bg-slate-50 p-4">
            <div className="flex flex-wrap gap-2 mb-2">
              {row.days.map((day) => (
                <span key={day} className="rounded-full bg-blue-100 px-3 py-1 text-sm font-medium text-blue-700">
                  {weekdays.find((w) => w.value === day)?.label || day}
                </span>
              ))}
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-700">
              <FiClock /> {row.startTime} – {row.endTime}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
